import { ReactElement } from 'react';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { MatchStatisticHeaderSkeleton } from './__partials/Header/Skeleton';
import { MatchStatisticHistorySkeleton } from './__partials/History/Skeleton';
import { MatchStatisticLastGamesSkeleton } from './__partials/LastGames/Skeleton';
import { MatchStatisticLeagueResultsSkeleton } from './__partials/LeagueResults/Skeleton';
import './index.less';

if (SpringConfigs.IS_RTL) {
  import('./rtl.less');
}

export const MatchStatisticPopoverSkeleton = (): ReactElement => {
  return (
    <>
      <MatchStatisticHeaderSkeleton />
      <MatchStatisticHistorySkeleton />
      <MatchStatisticLeagueResultsSkeleton />
      <MatchStatisticLastGamesSkeleton />
    </>
  );
};
